import { Injectable } from '@angular/core';

@Injectable()
export class QualityService {

  public pluginPartners: Array<any>;

  constructor() {
    this.pluginPartners = [
      { 'id': 4, 'name': "MOAT" },
    ];
  }


}
